export function calculateIsEligibleForFreeTrial(
  currentUser: {
    subscription_gateway_shortname: string | null;
  } | null,
) {
  const isEligibleForFreeTrial =
    currentUser === null || currentUser.subscription_gateway_shortname === null;
  return isEligibleForFreeTrial;
}
